import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import FloatingChatButton from '../components/FloatingChatButton';
import ContactForm from '../components/ContactForm';
import TestimonialVideoCarousel from '../components/TestimonialVideoCarousel';
import { Link } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://medical-linkers.onrender.com';

// Mock blogs data for recent blogs section
const recentBlogs = [
  {
    id: 1,
    title: "Medical Tourism: A Complete Guide",
    image: "/images/image copy 46.png",
    slug: "medical-tourism-complete-guide"
  },
  {
    id: 2,
    title: "How to Choose the Right Hospital Abroad",
    image: "/images/image copy 47.png", 
    slug: "how-to-choose-right-hospital-abroad"
  },
  {
    id: 3,
    title: "Understanding Medical Visa Requirements",
    image: "/images/image copy 48.png",
    slug: "understanding-medical-visa-requirements"
  },
  {
    id: 4,
    title: "Cost-Effective Treatment Options Overseas",
    image: "/images/image copy 49.png",
    slug: "cost-effective-treatment-options-overseas"
  }
];

const CaseStudyMain = () => {
  const [caseStudies, setCaseStudies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentBlogSlide, setCurrentBlogSlide] = useState(0);
  const blogsPerSlide = 1; // Changed to slide one by one
  const totalBlogSlides = recentBlogs.length;

  useEffect(() => {
    fetchCaseStudies();
  }, []);

  const fetchCaseStudies = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/case-studies?status=published`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch case studies');
      }
      
      const data = await response.json();
      setCaseStudies(data.caseStudies || []);
    } catch (error) {
      console.error('Error fetching case studies:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const nextBlogSlide = () => {
    setCurrentBlogSlide((prev) => (prev + 1) % totalBlogSlides);
  };

  const prevBlogSlide = () => {
    setCurrentBlogSlide((prev) => (prev - 1 + totalBlogSlides) % totalBlogSlides);
  };

  const getCurrentBlogs = () => {
    // Show 3 blogs at a time, starting from currentBlogSlide
    const blogs = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentBlogSlide + i) % totalBlogSlides;
      blogs.push(recentBlogs[index]);
    }
    return blogs;
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      
      {/* Case Studies Body Text */}
      <section className="blogsarticle-section py-12">
        <div className="container mx-auto px-4">
          <div className="titleHeading text-center mb-8">
            <h3 className="text-3xl md:text-4xl font-bold">
              <span className="text-[#1976f2]">Case </span> Studies
            </h3>
          </div>

          <div className="blogsListWrapper resoucesCardViewGrid">
            <div className="searchBySpecialityFilter">
              {/* Optional search/filter functionality can be added here */}
            </div>

            <div className="grid lg:grid-cols-4 gap-8">
              <div className="lg:col-span-3">
                {loading ? (
                  <div className="flex justify-center items-center min-h-96">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1976f2]"></div>
                  </div>
                ) : error ? (
                  <div className="text-center text-red-600 min-h-96 flex items-center justify-center">
                    <p>Error loading case studies: {error}</p>
                  </div>
                ) : caseStudies.length > 0 ? (
                  <div className="grid md:grid-cols-2 gap-6">
                    {caseStudies.map((caseStudy) => (
                      <div key={caseStudy._id || caseStudy.id} className="kcGridViewWrapper">
                        <div className="blogListBox mb-4">
                          <img 
                            src={caseStudy.featuredImage || "https://dummyimage.com/600x400/eeeeee/333333?text=Case+Study"} 
                            className="w-full h-48 object-cover rounded-lg" 
                            alt={caseStudy.title}
                            onError={(e) => {
                              e.target.src = "https://dummyimage.com/600x400/eeeeee/333333?text=Case+Study";
                            }}
                          />
                        </div>
                        <div className="articlesPublsihDate mb-2">
                          <p className="text-gray-600 text-sm">
                            Published on: {caseStudy.publishedAt ? new Date(caseStudy.publishedAt).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric'
                            }) : new Date(caseStudy.createdAt).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric'
                            })}
                          </p>
                        </div>
                        <div className="blogsListName">
                          <h4 className="text-lg font-semibold mb-2">
                            <Link 
                              to={`/case-study/${caseStudy.slug}`} 
                              className="text-[#1976f2] hover:text-blue-700 transition-colors"
                            >
                              {caseStudy.title}
                            </Link>
                          </h4>
                          <p className="text-gray-600 text-sm">
                            {caseStudy.excerpt || caseStudy.description}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center text-gray-600 min-h-96 flex items-center justify-center">
                    <p>No case studies available at the moment.</p>
                  </div>
                )}
              </div>

              <div className="lg:col-span-1">
                <div className="sidebarOuterWrapperRc">
                  <div className="sidebarCatgRWrapper">
                    <div className="sidebarCatgInnerBox bg-gray-50 p-6 rounded-lg">
                      <h4 className="text-lg font-semibold mb-4 text-[#1976f2]">Speciality</h4>
                      <div className="sidebarCatgRsBox">
                        <ul className="space-y-2">
                          <li><a href="#" className="text-gray-700 hover:text-[#1976f2] transition-colors">Cardiology</a></li>
                          <li><a href="#" className="text-gray-700 hover:text-[#1976f2] transition-colors">Oncology</a></li>
                          <li><a href="#" className="text-gray-700 hover:text-[#1976f2] transition-colors">Orthopedics</a></li>
                          <li><a href="#" className="text-gray-700 hover:text-[#1976f2] transition-colors">Neurology</a></li>
                          <li><a href="#" className="text-gray-700 hover:text-[#1976f2] transition-colors">Fertility</a></li>
                          <li><a href="#" className="text-gray-700 hover:text-[#1976f2] transition-colors">Pediatrics</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="getStartedPrefHosp bg-gray-50 py-12">
        <div className="container mx-auto px-4">
          <div className="getStartedHosWrappper">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div className="order-2 md:order-1">
                <div className="form-box">
                  <div className="costEstimateForm">
                    <div className="formInnerWrap">
                      <div className="subheadingBox mb-6">
                        <h2 className="text-2xl font-semibold mb-2">Start your treatment journey now</h2>
                        <p className="formSubheadDesc text-gray-600">Get in touch</p>
                      </div>
                      <ContactForm formType="case-study-inquiry" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="order-1 md:order-2">
                <div className="getStratDoctImgBox resourcesFormBanner">
                  <img 
                    src="/images/treatments/form-img.webp" 
                    className="w-full rounded-lg" 
                    alt="Treatment Journey"
                    onError={(e) => {
                      e.target.src = "https://dummyimage.com/600x400/eeeeee";
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Recent Blogs Section */}
      <section className="knowledgeCenterBlogs py-12">
        <div className="container mx-auto px-4">
          <div className="titleHeading text-center mb-8">
            <h3 className="text-3xl md:text-4xl font-bold">
              <span className="text-[#1976f2]">Recent </span> Blogs
            </h3>
          </div>

          <div className="recentBlogsWrapper">
            <div className="recentBlogsInnerBox">
              <div className="relative">
                <div className="grid md:grid-cols-3 gap-6">
                  {getCurrentBlogs().map((blog) => (
                    <div key={blog.id} className="rBlogsBox bg-white rounded-lg shadow-md overflow-hidden">
                      <img 
                        src={blog.image} 
                        className="w-full h-48 object-cover" 
                        alt={blog.title}
                        onError={(e) => {
                          e.target.src = "https://dummyimage.com/600x400/eeeeee";
                        }}
                      />
                      <div className="p-4">
                        <h4 className="text-lg font-semibold mb-3 text-gray-800">{blog.title}</h4>
                        <Link 
                          to={`/blogs/${blog.slug}`}
                          className="text-[#1976f2] hover:text-blue-700 font-medium inline-flex items-center transition-colors"
                        >
                          Read More <i className="ri-arrow-right-line ml-1"></i>
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Carousel Navigation - Buttons below */}
                <div className="flex justify-center space-x-4 mt-8">
                  <button
                    onClick={prevBlogSlide}
                    className="w-12 h-12 rounded-full bg-[#1976f2] hover:bg-blue-600 text-white transition-colors flex items-center justify-center"
                    aria-label="Previous Blogs"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                  <button
                    onClick={nextBlogSlide}
                    className="w-12 h-12 rounded-full bg-[#1976f2] hover:bg-blue-600 text-white transition-colors flex items-center justify-center"
                    aria-label="Next Blogs"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>

              <div className="viewallButtonRPages mt-8 text-center">
                <div className="buttonWrapper">
                  <Link to="/blogs/" className="inline-block bg-[#1976f2] text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium">
                    View all blogs
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonialSection bg-gray-50 py-12">
        <div className="container mx-auto px-4">
          <div className="titleHeading text-center mb-8">
            <h3 className="text-3xl md:text-4xl font-bold">
              <span className="text-[#1976f2]">Testimonials </span>
            </h3>
          </div>

          <div className="testimonialThirdPartyBox mb-8">
            <div className="grid md:grid-cols-3 gap-6 text-center">
              <div className="googleReviews">
                <p>
                  <a href="https://g.co/kgs/gYiMjat" target="_blank" rel="noopener noreferrer" className="inline-flex items-center">
                    <img src="/images/google-reviews.webp" className="w-32 mr-2" alt="Google Reviews" />
                    <span className="excellentText font-semibold">Excellent</span>
                    <span className="ratingStars text-yellow-400 ml-2">
                      <i className="ri-star-s-fill"></i>
                      <i className="ri-star-s-fill"></i>
                      <i className="ri-star-s-fill"></i>
                      <i className="ri-star-s-fill"></i>
                      <i className="ri-star-s-fill"></i>
                    </span>
                  </a>
                </p>
              </div>

              <div className="reviewsTextInfo">
                <p className="text-lg">
                  Trusted by over <br />
                  <span className="font-bold text-2xl">25000 </span> international patients
                </p>
              </div>

              <div className="googleReviews">
                <p>
                  <a href="https://www.facebook.com/medicallinkers/reviews" target="_blank" rel="noopener noreferrer" className="inline-flex items-center">
                    <img src="/images/facebook-logo.PNG" className="w-35 mr-2" alt="Facebook Reviews" />
                    <span className="excellentText font-semibold">Excellent</span>
                    <span className="ratingStars text-yellow-400 ml-2">
                      <i className="ri-star-s-fill"></i>
                      <i className="ri-star-s-fill"></i>
                      <i className="ri-star-s-fill"></i>
                      <i className="ri-star-s-fill"></i>
                      <i className="ri-star-s-fill"></i>
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="testimonailSayWrapper">
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h4 className="text-lg italic mb-4">
                  "Medical Linkers, guided by Miss Sonam, helped me find the right clinic in Istanbul for my hair transplant. Grateful for their expertise and support!"
                </h4>
                <div className="customerNameBox">
                  <div className="flex items-center">
                    <div className="w-16 h-16 mr-4">
                      <img src="/images/customer-testimonial/ahmmed-zia.png" alt="Ahmed Zia" className="w-full h-full rounded-full object-cover" />
                    </div>
                    <div className="customerNameInfo">
                      <h5 className="font-semibold">Ahmed Zia</h5>
                      <p className="text-gray-600">2018-05-17</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="callToActionBtn testimonialBtnBox mt-8 text-center">
              <div className="buttonWrapper space-x-4">
                <button className="bg-[#1976f2] text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium">
                  Get a call back
                </button>
                <a href="#" className="bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition-colors font-medium inline-flex items-center">
                  <i className="ri-whatsapp-line mr-2"></i> Chat Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="doctorsTreatmentCallAction bg-[#1976f2] py-8">
        <div className="container mx-auto px-4">
          <div className="callToactionWrap">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="callActionText mb-4 md:mb-0">
                <h4 className="text-white text-2xl font-semibold">Search For Your Treatment</h4>
              </div>
              <div className="callActionBtnWrap">
                <a href="#" className="bg-white text-[#1976f2] px-6 py-3 rounded-lg hover:bg-gray-100 transition-colors font-medium">
                  Explore More
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Videos Section */}
      <TestimonialVideoCarousel 
        title="Patient Testimonial Videos"
        limit={6}
        className="bg-gray-50"
      />

      <Footer />
      <FloatingChatButton />
    </div>
  );
};

export default CaseStudyMain;
